import {
  AtLeast,
  Block,
  CommonBlocksCompoundIndexes,
  ComponentBlock,
  DocumentBlock,
  InstanceBlock,
  ReferenceBlock,
  isReferenceBlock,
} from '@basehub/data/replicache/index'
import { TreeManager } from '@basehub/utils/tree/index'

export const getInvalidReferencedBlock = (id: string): ComponentBlock => ({
  id: `invalid-reference-${id}`,
  type: 'component',
  title: `Unresolved reference (${id})`,
  constraints: {},
  value: { children: [] },
  createdAt: new Date().toISOString(),
  isCommitted: false,
  typeOptions: {
    displayTitle: '',
    displayDescription: '',
    displayIcon: '',
  },
  hidden: false,
})

export const getBlocksToRender = (
  block: DocumentBlock | ComponentBlock | InstanceBlock | ReferenceBlock,
  blockTreeManager: AtLeast<
    TreeManager<Block, CommonBlocksCompoundIndexes>,
    'getNode' | 'getChildrenKeys'
  >
): Block[] => {
  if (isReferenceBlock(block)) {
    return block.value.targetBlockIds.map(
      (id) =>
        blockTreeManager.getNode(id)?.value ?? getInvalidReferencedBlock(id)
    )
  }

  try {
    return (blockTreeManager.getChildrenKeys(block.id) ?? []).map(
      (cId) => blockTreeManager.getNode(cId, { required: true }).value
    )
  } catch (err) {
    return []
  }
}
